import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ApiAuditActionConstants } from "../../constants/api-constants/api-audit-action.constants";
let ApplicationHistoryService = class ApplicationHistoryService {
    http;
    constructor(http) {
        this.http = http;
    }
    getAuditActionObservable(params) {
        return this.http.get(ApiAuditActionConstants.URL, { params });
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
ApplicationHistoryService = __decorate([
    Injectable({
        providedIn: "root"
    })
], ApplicationHistoryService);
export { ApplicationHistoryService };
